import { useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { axios } from "../../lib/request";
import { useItemQuery } from "../../Global.state";
import { judgeQueryKey } from "../../lib/refresh";

export const fetchJudges = async (game_id) => {
    if (game_id === "new") {
        return { judges: [] };
    }

    const { data } = await axios.get(process.env.REACT_APP_API_JUDGE_URL, {
        params: {
            game_id,
        },
    });
    data.judges = (data.judges || []).map(judge => {
        if (judge?.media_url) {
            // Transform judge media into standard structure
            judge.assets = {
                photos: [{
                    name: 'media',
                    url: judge.media_url,
                }]
            }
        }
        return judge
    })
    return data
};

export const useJudgeQuery = ({ taskId }) => {
    const { game_id } = useParams();
    return useQuery(
        judgeQueryKey(game_id, taskId),
        () => fetchJudges(game_id),
        {
            select: (data) => {
                const judgeData = (data?.data || data) || {}
                judgeData.judges = (judgeData.judges || []).map(judge => {
                    judge.active = Number(judge.active)
                    judge.mode = Number(judge.mode)
                    return judge
                })
                return judgeData
            },
        },
    )
}

export const useCreateJudgeMutation = ({ taskId }) => {
    const { game_id } = useParams();
    const queryKey = judgeQueryKey(game_id, taskId)
    const queryClient = useQueryClient()

    return useMutation(
        () => axios.post(process.env.REACT_APP_API_JUDGE_URL, {
            game_id,
            task_id: taskId
        }),
        {
            onSuccess: (data) => {
                const current = queryClient.getQueryData(queryKey);
                const newJudges = [
                    ...(current?.judges || []),
                    data?.judge || {
                        game_id,
                        task_id: taskId,
                    }
                ]
                queryClient.setQueryData(queryKey, {
                    ...current,
                    judges: newJudges,
                });
                queryClient.invalidateQueries(queryKey)
            },
        }
    )
}

export const updateJudge = async (id, params) => {
    const url = `${process.env.REACT_APP_API_JUDGE_UPDATE_URL}/${id}.json`;
    return await axios.put(url, params);
}

export const useJudgeItemQuery = ({ taskId, id, judgeQuery }) => {
    const { game_id } = useParams();
    const { data, isFetching } = judgeQuery;
    const currentParams = (data?.judges || []).find(j => j.id === id);
    // Exclude assets from the request payload. Otherwise it will trigger Payload Too Large error.
    const { assets, ...rest } = currentParams
    const queryKey = judgeQueryKey(game_id, taskId);
    const setter = (params) => updateJudge(id, {
        ...rest,
        ...params,
    });
    return [...useItemQuery(data, id, "judges", queryKey, setter), isFetching];
}